import { NotificationService } from './../../../../Services/notification.service';
import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { OrderCreationService } from '../../../../Services/order-creation.service';
import Swal from 'sweetalert2';
import { AdminAssetsComponent } from '../../Admin/admin-assets/admin-assets.component';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-admin-kalakar',
  imports: [
    ReactiveFormsModule,
    NgIf,
    NgFor,
    CommonModule,
    FormsModule,
    AdminAssetsComponent,
  ],
  templateUrl: './admin-kalakar.component.html',
  styleUrl: './admin-kalakar.component.css',
})
export class AdminKalakarComponent implements OnInit {
  @Input() kalakarId?: number | null;
  @Input() role?: string | null;
  @Output() back = new EventEmitter<void>();

  activeTab: string = 'orders';
  orders: any[] = [];
  showStatusModal = false;
  selectedOrder: any = null;
  selectedStatus = 'pending';
  showApprovalModal = false;
  approvedQty: number = 0;

  transactions: any[] = [];
  isLoadingTransactions = false;
  fromDate: string = '';
  toDate: string = '';
  currentPage: number = 1;
  pageSize: number = 10;
  totalTransactions: number = 0;
  lastPage: number = 1;
  txPageNumbers: number[] = [];

  // Pagination for Orders
  ordersCurrentPage: number = 1;
  ordersPageSize: number = 10;
  totalOrders: number = 0;
  ordersLastPage: number = 1;

  isLoading = false;
  protected Math = Math;

  constructor(
    private route: ActivatedRoute,
    private ordersService: OrderCreationService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    // try current route
    let sId = this.route.snapshot.paramMap.get('staffId');
    let sName = this.route.snapshot.paramMap.get('staffName');

    // fallback to parent (useful if params are defined on parent route)
    if (!sId && this.route.parent) {
      sId = this.route.parent.snapshot.paramMap.get('staffId') || sId;
      sName = this.route.parent.snapshot.paramMap.get('staffName') || sName;
    }

    // fallback to root (in case params are higher)
    if (!sId && this.route.root) {
      sId = this.route.root.snapshot.paramMap.get('staffId') || sId;
      sName = this.route.root.snapshot.paramMap.get('staffName') || sName;
    }

    // last resort: keep your old logic (query params or localStorage)
    if (!sId) {
      sId = this.route.snapshot.queryParamMap.get('id') || localStorage.getItem('supplierId') || null;
    }

    this.kalakarId = sId ? Number(sId) : null;
    this.role = sName ? decodeURIComponent(sName) : (this.role ?? null);

    console.log('Resolved staffId ->', this.kalakarId, 'staffName ->', this.role);

    if (!this.kalakarId) {
      console.error('No Staff ID provided in route / query / localStorage!');
      return;
    }

    // Fetch initial data
    this.getOrders();
  }

  private formatDate(date: Date): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }


  setActiveTab(tab: string) {
    this.activeTab = tab;
    if (tab === 'transactions') {
      this.currentPage = 1;
      this.getKalakarTransactions();
    } else if (tab === 'orders') {
      this.ordersCurrentPage = 1;
      this.getOrders();
    }
  }

  ordersPageNumbers: number[] = [];

  getOrders(page: number = 1) {
    this.isLoading = true;
    this.ordersCurrentPage = page;
    const params = new HttpParams()
      .set('supplier_id', String(this.kalakarId))
      .set('page', String(this.ordersCurrentPage))
      .set('per_page', String(this.ordersPageSize));

    this.ordersService.getOrders(params).subscribe({
      next: (res: any) => {
        // Handle paginated response
        const pData = res?.data ?? res;

        this.orders = Array.isArray(pData?.data)
          ? pData.data
          : Array.isArray(pData)
          ? pData
          : [];
          
        console.log("Order data is",this.orders);
        
        this.totalOrders = pData?.total || 0;
        this.ordersLastPage = pData?.last_page || 1;

        // Generate page numbers
        this.generateOrdersPageNumbers();

        console.log('Fetched paginated orders:', this.orders);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching orders:', err);
        this.isLoading = false;
      },
    });
  }

  generateOrdersPageNumbers() {
    const pages: number[] = [];
    const maxVisible = 5;
    let start = Math.max(1, this.ordersCurrentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.ordersLastPage, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    this.ordersPageNumbers = pages;
  }

  onOrderPageChange(page: number) {
    this.getOrders(page);
  }

  onOrderPageSizeChange() {
    this.ordersCurrentPage = 1;
    this.getOrders(1);
  }

  goBack() {
    this.back.emit();
  }

  closeStatusModal() {
    this.showStatusModal = false;
    this.selectedOrder = null;
  }

  updatePaymentStatus(order: any, newStatus: string) {
    console.log('status is', order.status);
    if (order.status !== 'completed') {
      this.notificationService.showWarning(
        'You can only mark payment as Paid after the order is completed.',
        'Warning'
      );
      return;
    }

    this.ordersService
      .updateOrder(order.id, {
        ordc_payment_status: newStatus,
      })
      .subscribe({
        next: (res) => {
          this.notificationService.showSuccess(
            'Payment status updated successfully',
            'Success'
          );
          this.getOrders();
        },
        error: (err) => {
          this.notificationService.showError(
            'Failed to update payment status',
            'Error'
          );
          console.error('Error updating payment status:', err);
        },
      });
  }

  openPaymentModal(order: any) {
    const remainingAmount = Number((order.ordc_labour_charges / order.quantity) * order.approved_quantity - order.ordc_last_payment || 0);

    if (remainingAmount <= 0) {
      this.notificationService.showWarning(
        'No pending labour payment for this order.',
        'Warning'
      );
      return;
    }

    Swal.fire({
      title: 'Pay Labour Charges',
      html: `
        <p class="text-gray-600 text-sm mb-2">
          Remaining Labour Amount:
          <strong>₹ ${remainingAmount.toFixed(2)}</strong>
        </p>
      `,
      input: 'number',
      inputValue: remainingAmount,
      inputAttributes: {
        min: '0.01',
        max: remainingAmount.toString(),
        step: '0.01',
      },
      showCancelButton: true,
      confirmButtonText: 'Pay',
      cancelButtonText: 'Cancel',
      backdrop: `rgba(0,0,0,0.4) blur(6px)`,
      customClass: {
        popup: 'rounded-2xl shadow-2xl p-6',
        confirmButton:
          'bg-[#c19725] text-white rounded-md px-4 py-2 hover:bg-[#a87f1f]',
        cancelButton:
          'bg-gray-200 text-gray-800 rounded-md px-4 py-2 hover:bg-gray-300',
      },
      buttonsStyling: false,

      preConfirm: (value) => {
        const paidAmt = Number(value);

        if (!paidAmt || paidAmt <= 0) {
          Swal.showValidationMessage('Please enter a valid amount.');
          return false;
        }

        if (paidAmt > remainingAmount) {
          Swal.showValidationMessage(
            'Payment amount cannot exceed remaining labour charges.'
          );
          return false;
        }

        return paidAmt;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.payLabourAmount(order.id, result.value);
      }
    });
  }

  payLabourAmount(orderId: number, amount: number) {
    this.ordersService.payLabourAmount(orderId, amount).subscribe({
      next: () => {
        this.notificationService.showSuccess(
          'Labour payment recorded successfully',
          'Success'
        );
        this.getOrders();
      },
      error: (err: { error: { message: any; }; }) => {
        this.notificationService.showError(
          err.error?.message || 'Payment failed',
          'Error'
        );
      },
    });
  }

  openApprovalModal(order: any) {
    this.selectedOrder = order;
    this.approvedQty = order.ready_quantity; // default to full ready qty
    this.showApprovalModal = true;
  }

  closeApprovalModal() {
    this.showApprovalModal = false;
    this.selectedOrder = null;
    this.approvedQty = 0;
  }

  approveQuantity() {
    if (!this.selectedOrder) return;
    console.log('selected order', this.selectedOrder);
    const totalQuantity = Number(this.selectedOrder.quantity || 0);
    if (this.approvedQty < 0) {
      this.notificationService.showWarning(
        'Quantity cannot be negative.',
        'Warning'
      );
      return;
    }

    if (this.approvedQty > this.selectedOrder.ready_quantity) {
      this.notificationService.showWarning(
        'Approved quantity cannot exceed ready quantity.',
        'Warning'
      );
      return;
    }

    const rejectedQty = this.selectedOrder.ready_quantity - this.approvedQty;
    const previousApproved = this.selectedOrder.approved_quantity || 0;
    const totalApproved = Number(previousApproved) + Number(this.approvedQty);

    console.log('total quantity 1', totalQuantity);

    let finalStatus = 'pending';

    if (totalApproved == this.selectedOrder.quantity) {
      finalStatus = 'completed';
    }

    console.log('total approved', totalApproved);
    console.log('total quantity', this.selectedOrder.quantity);
    console.log('total quantity', this.selectedOrder.quantity);
    console.log('final status', finalStatus);

    const payload: any = {
      ordc_approved_quantity: totalApproved,
      ordc_rejected_quantity:
        (this.selectedOrder.ordc_rejected_quantity || 0) + rejectedQty,
      ordc_ready_quantity: 0,
      ordc_request_status: 'reviewed',
      ordc_status: finalStatus,
      ordc_last_approved_quantity: this.approvedQty,
      ordc_last_rejected_quantity: rejectedQty,
      ordc_available_quantity: Math.max(
        (this.selectedOrder.ordc_available_quantity || 0) - this.approvedQty,
        0
      ),
    };

    if (totalApproved >= this.selectedOrder.ordc_quantity) {
      payload.ordc_status = 'completed';
    }

    this.ordersService.updateOrder(this.selectedOrder.id, payload).subscribe({
      next: (res) => {
        this.notificationService.showSuccess(
          'Order approval updated successfully!',
          'Success'
        );
        this.closeApprovalModal();
        console.log('updated approval', res);
        this.getOrders();
      },
      error: (err) => {
        console.error('Error updating order:', err);
        this.notificationService.showError(
          'Failed to update approval.',
          'Error'
        );
      },
    });
  }

  approveReturn(orderId: number) {
    Swal.fire({
      title: 'Approve Raw Material Return?',
      text: 'Stock will be restored.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Approve',
    }).then(result => {
      if (result.isConfirmed) {
        this.ordersService.approveRawMaterialReturn(orderId).subscribe({
          next: () => {
            this.notificationService.showSuccess(
              'Raw material returned & stock restored',
              'Success'
            );
            this.getOrders();
          },
          error: err => {
            this.notificationService.showError(
              err.error?.message || 'Approval failed',
              'Error'
            );
          },
        });
      }
    });
  }

  getKalakarTransactions(page: number = 1) {
    if (!this.kalakarId) return;

    this.currentPage = page;
    this.isLoadingTransactions = true;
    const firmId = localStorage.getItem('firm_id');

    let params = new HttpParams()
      .set('kalakar_id', String(this.kalakarId))
      .set('page', String(this.currentPage))
      .set('per_page', String(this.pageSize));

    if (this.fromDate) {
      params = params.set('from_date', this.fromDate);
    }
    if (this.toDate) {
      params = params.set('to_date', this.toDate);
    }

    this.ordersService.getKalakarTransactions(params).subscribe({
      next: (res: any) => {
        const pData = res?.data || res;
        this.transactions = pData?.data || [];
        this.totalTransactions = pData?.total || 0;
        this.lastPage = pData?.last_page || 1;
        this.generateTxPageNumbers();
        this.isLoadingTransactions = false;
        console.log('Fetched transactions:', this.transactions);
      },
      error: (err) => {
        console.error('Error fetching transactions:', err);
        this.isLoadingTransactions = false;
      },
    });
  }

  generateTxPageNumbers() {
    const pages: number[] = [];
    const maxVisible = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(this.lastPage, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    this.txPageNumbers = pages;
  }

  getColorizedRemark(remark: string): string {
    if (!remark) return '—';

    // Logic: Admin OUT = Kalakar IN = Green
    // Admin IN = Kalakar OUT = Red
    if (remark.startsWith('IN:')) {
      return `<strong class="text-red-600">${remark.substring(0, 3)}</strong>${remark.substring(3)}`;
    }
    if (remark.startsWith('OUT:')) {
      return `<strong class="text-green-600">${remark.substring(0, 4)}</strong>${remark.substring(4)}`;
    }
    if (remark.startsWith('READY:')) {
      return `<strong class="text-blue-600">${remark.substring(0, 6)}</strong>${remark.substring(6)}`;
    }
    return remark;
  }

  onPageChange(page: number) {
    this.getKalakarTransactions(page);
  }

  onPageSizeChange() {
    this.currentPage = 1;
    this.getKalakarTransactions(1);
  }

  clearTransactionsFilter() {
    this.fromDate = '';
    this.toDate = '';
    this.currentPage = 1;
    this.getKalakarTransactions();
  }

  formatTransactionType(type: string): string {
    if (!type) return '';
    return type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  // EXPORT FUNCTIONS

  downloadOrdersPDF() {
    const doc = new jsPDF('l', 'mm', 'a4');
    const headers = [['Order ID', 'Product', 'Total Qty', 'Approved Qty', 'Rejected Qty', 'Status', 'Payment', 'Date']];
    const data = this.orders.map(order => [
      order.id,
      order.product_name,
      order.quantity,
      order.approved_quantity,
      order.rejected_quantity,
      order.status,
      order.ordc_payment_status,
      new Date(order.created_at).toLocaleDateString()
    ]);

    doc.setFontSize(16);
    doc.text(`Order List - Kalakar: ${this.role || this.kalakarId}`, 14, 15);

    autoTable(doc, {
      head: headers,
      body: data,
      theme: 'grid',
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [66, 133, 244] }
    });

    doc.save(`Orders_${this.role || this.kalakarId}_${new Date().getTime()}.pdf`);
  }

  printOrders() {
    let printContent = `
      <html>
        <head>
          <title>Order List</title>
          <style>
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-family: sans-serif; font-size: 12px; }
            th { background-color: #f2f2f2; }
            h2 { font-family: sans-serif; color: #333; }
          </style>
        </head>
        <body>
          <h2>Order List - Kalakar: ${this.role || this.kalakarId}</h2>
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Product</th>
                <th>Total Qty</th>
                <th>Approved Qty</th>
                <th>Rejected Qty</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              ${this.orders.map(order => `
                <tr>
                  <td>${order.id}</td>
                  <td>${order.product_name}</td>
                  <td>${order.quantity}</td>
                  <td>${order.approved_quantity}</td>
                  <td>${order.rejected_quantity}</td>
                  <td>${order.status}</td>
                  <td>${order.ordc_payment_status}</td>
                  <td>${new Date(order.created_at).toLocaleDateString()}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    }
  }

  downloadTransactionsPDF() {
    const doc = new jsPDF('l', 'mm', 'a4');
    const headers = [['Date', 'Type', 'Code', 'Product Name', 'Quantity', 'Amount', 'Remarks', 'Admin']];
    const data = this.transactions.map(tx => [
      new Date(tx.created_at).toLocaleString(),
      this.formatTransactionType(tx.ot_type),
      tx.ot_product_code,
      tx.ot_product_name,
      tx.ot_quantity,
      tx.ot_amount || '—',
      tx.ot_remarks || '—',
      tx.createdBy?.name || '—'
    ]);

    doc.setFontSize(16);
    doc.text(`Transaction History - Kalakar: ${this.role || this.kalakarId}`, 14, 15);

    autoTable(doc, {
      head: headers,
      body: data,
      theme: 'grid',
      startY: 20,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [66, 133, 244] }
    });

    doc.save(`Transactions_${this.role || this.kalakarId}_${new Date().getTime()}.pdf`);
  }

  printTransactions() {
    let printContent = `
      <html>
        <head>
          <title>Transaction History</title>
          <style>
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-family: sans-serif; font-size: 10px; }
            th { background-color: #f2f2f2; }
            h2 { font-family: sans-serif; color: #333; }
            .remark-in { color: #dc2626; font-weight: bold; }
            .remark-out { color: #16a34a; font-weight: bold; }
          </style>
        </head>
        <body>
          <h2>Transaction History - Kalakar: ${this.role || this.kalakarId}</h2>
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Code</th>
                <th>Product Name</th>
                <th>Quantity</th>
                <th>Amount</th>
                <th>Remarks</th>
                <th>Admin</th>
              </tr>
            </thead>
            <tbody>
              ${this.transactions.map(tx => {
      let remark = tx.ot_remarks || '—';
      let remarkStyled = remark;
      if (remark.startsWith('IN:')) {
        remarkStyled = `<span class="remark-in">IN:</span>${remark.substring(3)}`;
      } else if (remark.startsWith('OUT:')) {
        remarkStyled = `<span class="remark-out">OUT:</span>${remark.substring(4)}`;
      }

      return `
                <tr>
                  <td>${new Date(tx.created_at).toLocaleString()}</td>
                  <td>${this.formatTransactionType(tx.ot_type)}</td>
                  <td>${tx.ot_product_code}</td>
                  <td>${tx.ot_product_name}</td>
                  <td>${tx.ot_quantity}</td>
                  <td>${tx.ot_amount || '—'}</td>
                  <td>${remarkStyled}</td>
                  <td>${tx.createdBy?.name || '—'}</td>
                </tr>
              `}).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    }
  }
}